import React from 'react';
import './StatCard.css';

export function StatCard({ title, value, icon: Icon, trend, onClick }) {
  const isPositive = trend && trend.includes('↑');
  const isNegative = trend && trend.includes('↓');

  return (
    <div className="stat-card" onClick={onClick} role="button" tabIndex={0}>
      <div className="stat-card-header">
        <div>
          <p className="stat-title">{title}</p>
          <h3 className="stat-value">{value}</h3>
        </div>
        <div className="stat-icon-wrapper">
          {Icon && <Icon size={24} className="stat-icon" />}
        </div>
      </div>
      {trend && (
        <div className={`stat-trend ${isPositive ? 'positive' : isNegative ? 'negative' : ''}`}>
          <span className="trend-text">{trend}</span>
        </div>
      )}
    </div>
  );
}
